var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "homeItems homeItems--design" },
    [
      !_vm.$screen.mobile
        ? _c("RollBox", {
            attrs: {
              roiiListLoading: _vm.roiiListLoading,
              roiiHeroBg: _vm.roiiHeroBg,
              roiiList: _vm.roiiList,
            },
          })
        : _vm._e(),
      _c(
        "aside",
        { staticClass: "live-drop-container" },
        [_c("p-live-drop-box")],
        1
      ),
      _vm.noticeList.length
        ? _c("div", { staticClass: "design-notice-bar" }, [
            _c(
              "svg",
              {
                staticClass:
                  "design-notice-bar__icon design-notice-bar__icon--warn",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "23",
                  viewBox: "0 0 24 23",
                  fill: "none",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M16.0206 0C16.4584 0 16.8144 0.345602 16.8245 0.775759L16.8248 0.794513L16.8247 2.93355H21.835C23.0307 2.93355 24 3.89125 24 5.07262V16.0124C24 17.1937 23.0307 18.1514 21.835 18.1514H16.0177L19.3207 21.1175L19.3359 21.1315C19.65 21.4283 19.669 21.9202 19.3749 22.2399C19.0762 22.5646 18.5677 22.5886 18.239 22.2934L13.6266 18.1514H10.3491L5.73673 22.2934C5.40807 22.5886 4.8995 22.5646 4.60082 22.2399C4.30679 21.9202 4.3257 21.4283 4.63983 21.1315L4.65503 21.1175L7.95802 18.1514H2.16492C0.969309 18.1514 0 17.1938 0 16.0124V5.07265C0 3.89125 0.969283 2.93358 2.16495 2.93358L7.17525 2.93355V0.794513L7.17549 0.775759C7.18555 0.345602 7.54162 0 7.97938 0C8.42349 0 8.78352 0.355696 8.78352 0.794513L8.78349 2.93355H15.2165V0.794513C15.2165 0.355723 15.5765 0 16.0206 0ZM18.5258 12.1926H5.50515L5.48618 12.1928C5.05084 12.2028 4.70104 12.5546 4.70104 12.9871C4.70104 13.4216 5.05388 13.7745 5.49186 13.7816L5.50515 13.7817H18.5258L18.5448 13.7814C18.9802 13.7715 19.3299 13.4197 19.3299 12.9871C19.3299 12.5484 18.9699 12.1926 18.5258 12.1926ZM18.5258 7.30336H5.50515L5.48618 7.30357C5.05084 7.31354 4.70104 7.66535 4.70104 8.09785C4.70104 8.53228 5.05388 8.88524 5.49186 8.89228L5.50515 8.89239H18.5258L18.5448 8.89215C18.9802 8.88219 19.3299 8.5304 19.3299 8.09787C19.3299 7.65908 18.9699 7.30334 18.5258 7.30334V7.30336Z",
                    fill: "#F5B844",
                  },
                }),
              ]
            ),
            _c("div", { staticClass: "design-notice-bar__scroll-wrap" }, [
              _c(
                "div",
                {
                  staticClass: "design-notice-bar__roll",
                  class: {
                    "design-notice-bar__roll--animate":
                      _vm.noticeList.length > 1,
                  },
                },
                _vm._l(_vm.noticeList, function (item, i) {
                  return _c(
                    "div",
                    {
                      key: (item.id != null ? item.id : i) + "-" + i,
                      staticClass:
                        "design-notice-bar__text design-notice-bar__item",
                    },
                    [_vm._v(_vm._s(item.notice))]
                  )
                }),
                0
              ),
            ]),
          ])
        : _vm._e(),
      _c("div", { staticClass: "design-cards design-cards--blocks" }, [
        _c("div", { staticClass: "block-left" }, [
          _vm.designCards[0]
            ? _c(
                "a",
                {
                  staticClass:
                    "design-card design-card--tall design-card--left",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.pathGo(
                        _vm.designCards[0].route,
                        _vm.designCards[0].featureKey
                      )
                    },
                  },
                },
                [
                  _c("span", { staticClass: "design-card__title" }, [
                    _vm._v(_vm._s(_vm.designCards[0].name)),
                  ]),
                  _c(
                    "div",
                    { staticClass: "design-card__img" },
                    [
                      _vm.designCards[0].bgImage
                        ? _c(
                            "el-image",
                            {
                              staticClass: "design-card__img-inner",
                              attrs: {
                                src: _vm.designCards[0].bgImage,
                                fit: "cover",
                              },
                            },
                            [
                              _c("template", { slot: "placeholder" }, [
                                _c("div", {
                                  staticClass: "design-card__img-skeleton",
                                }),
                              ]),
                            ],
                            2
                          )
                        : _c("div", {
                            staticClass: "design-card__img-bg",
                            style: _vm.designCards[0].bgStyle,
                          }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _c("div", { staticClass: "sub-block design-cards--blocks" }, [
            _c(
              "a",
              {
                staticClass: "sub-block-top design-card design-card--wide",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.pathGo(
                      _vm.designCards[1][0][0].route,
                      _vm.designCards[1][0][0].featureKey
                    )
                  },
                },
              },
              [
                _c("span", { staticClass: "design-card__title" }, [
                  _vm._v(_vm._s(_vm.designCards[1][0][0].name)),
                ]),
                _c(
                  "div",
                  { staticClass: "design-card__img" },
                  [
                    _vm.designCards[1][0][0].bgImage
                      ? _c(
                          "el-image",
                          {
                            staticClass: "design-card__img-inner",
                            attrs: {
                              src: _vm.designCards[1][0][0].bgImage,
                              fit: "cover",
                            },
                          },
                          [
                            _c("template", { slot: "placeholder" }, [
                              _c("div", {
                                staticClass: "design-card__img-skeleton",
                              }),
                            ]),
                          ],
                          2
                        )
                      : _c("div", {
                          staticClass: "design-card__img-bg",
                          style: _vm.designCards[1][0][0].bgStyle,
                        }),
                  ],
                  1
                ),
              ]
            ),
            _c("div", { staticClass: "sub-block-bottom" }, [
              _c(
                "a",
                {
                  staticClass: "design-card design-card--square",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.pathGo(
                        _vm.designCards[1][1][0].route,
                        _vm.designCards[1][1][0].featureKey
                      )
                    },
                  },
                },
                [
                  _c("span", { staticClass: "design-card__title" }, [
                    _vm._v(_vm._s(_vm.designCards[1][1][0].name)),
                  ]),
                  _c(
                    "div",
                    { staticClass: "design-card__img" },
                    [
                      _vm.designCards[1][1][0].bgImage
                        ? _c(
                            "el-image",
                            {
                              staticClass: "design-card__img-inner",
                              attrs: {
                                src: _vm.designCards[1][1][0].bgImage,
                                fit: "cover",
                              },
                            },
                            [
                              _c("template", { slot: "placeholder" }, [
                                _c("div", {
                                  staticClass: "design-card__img-skeleton",
                                }),
                              ]),
                            ],
                            2
                          )
                        : _c("div", {
                            staticClass: "design-card__img-bg",
                            style: _vm.designCards[1][1][0].bgStyle,
                          }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "a",
                {
                  staticClass: "design-card design-card--square",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.pathGo(
                        _vm.designCards[1][1][1].route,
                        _vm.designCards[1][1][1].featureKey
                      )
                    },
                  },
                },
                [
                  _c("span", { staticClass: "design-card__title" }, [
                    _vm._v(_vm._s(_vm.designCards[1][1][1].name)),
                  ]),
                  _c(
                    "div",
                    { staticClass: "design-card__img" },
                    [
                      _vm.designCards[1][1][1].bgImage
                        ? _c(
                            "el-image",
                            {
                              staticClass: "design-card__img-inner",
                              attrs: {
                                src: _vm.designCards[1][1][1].bgImage,
                                fit: "cover",
                              },
                            },
                            [
                              _c("template", { slot: "placeholder" }, [
                                _c("div", {
                                  staticClass: "design-card__img-skeleton",
                                }),
                              ]),
                            ],
                            2
                          )
                        : _c("div", {
                            staticClass: "design-card__img-bg",
                            style: _vm.designCards[1][1][1].bgStyle,
                          }),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "block-right" }, [
          _c("div", { staticClass: "sub-block design-cards--blocks" }, [
            _c(
              "a",
              {
                staticClass: "sub-block-top design-card design-card--wide",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.pathGo(
                      _vm.designCards[1][0][1].route,
                      _vm.designCards[1][0][1].featureKey
                    )
                  },
                },
              },
              [
                _c("span", { staticClass: "design-card__title" }, [
                  _vm._v(_vm._s(_vm.designCards[1][0][1].name)),
                ]),
                _c(
                  "div",
                  { staticClass: "design-card__img" },
                  [
                    _vm.designCards[1][0][1].bgImage
                      ? _c(
                          "el-image",
                          {
                            staticClass: "design-card__img-inner",
                            attrs: {
                              src: _vm.designCards[1][0][1].bgImage,
                              fit: "cover",
                            },
                          },
                          [
                            _c("template", { slot: "placeholder" }, [
                              _c("div", {
                                staticClass: "design-card__img-skeleton",
                              }),
                            ]),
                          ],
                          2
                        )
                      : _c("div", {
                          staticClass: "design-card__img-bg",
                          style: _vm.designCards[1][0][1].bgStyle,
                        }),
                  ],
                  1
                ),
              ]
            ),
            _c("div", { staticClass: "sub-block-bottom" }, [
              _c(
                "a",
                {
                  staticClass: "design-card design-card--square",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.pathGo(
                        _vm.designCards[1][1][2].route,
                        _vm.designCards[1][1][2].featureKey
                      )
                    },
                  },
                },
                [
                  _c("span", { staticClass: "design-card__title" }, [
                    _vm._v(_vm._s(_vm.designCards[1][1][2].name)),
                  ]),
                  _c(
                    "div",
                    { staticClass: "design-card__img" },
                    [
                      _vm.designCards[1][1][2].bgImage
                        ? _c(
                            "el-image",
                            {
                              staticClass: "design-card__img-inner",
                              attrs: {
                                src: _vm.designCards[1][1][2].bgImage,
                                fit: "cover",
                              },
                            },
                            [
                              _c("template", { slot: "placeholder" }, [
                                _c("div", {
                                  staticClass: "design-card__img-skeleton",
                                }),
                              ]),
                            ],
                            2
                          )
                        : _c("div", {
                            staticClass: "design-card__img-bg",
                            style: _vm.designCards[1][1][2].bgStyle,
                          }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "a",
                {
                  staticClass: "design-card design-card--square",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.pathGo(
                        _vm.designCards[1][1][3].route,
                        _vm.designCards[1][1][3].featureKey
                      )
                    },
                  },
                },
                [
                  _c("span", { staticClass: "design-card__title" }, [
                    _vm._v(_vm._s(_vm.designCards[1][1][3].name)),
                  ]),
                  _c(
                    "div",
                    { staticClass: "design-card__img" },
                    [
                      _vm.designCards[1][1][3].bgImage
                        ? _c(
                            "el-image",
                            {
                              staticClass: "design-card__img-inner",
                              attrs: {
                                src: _vm.designCards[1][1][3].bgImage,
                                fit: "cover",
                              },
                            },
                            [
                              _c("template", { slot: "placeholder" }, [
                                _c("div", {
                                  staticClass: "design-card__img-skeleton",
                                }),
                              ]),
                            ],
                            2
                          )
                        : _c("div", {
                            staticClass: "design-card__img-bg",
                            style: _vm.designCards[1][1][3].bgStyle,
                          }),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ]),
          _vm.designCards[2]
            ? _c(
                "a",
                {
                  staticClass:
                    "design-card design-card--tall design-card--left",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.pathGo(
                        _vm.designCards[2].route,
                        _vm.designCards[2].featureKey
                      )
                    },
                  },
                },
                [
                  _c("span", { staticClass: "design-card__title" }, [
                    _vm._v(_vm._s(_vm.designCards[2].name)),
                  ]),
                  _c(
                    "div",
                    { staticClass: "design-card__img" },
                    [
                      _vm.designCards[2].bgImage
                        ? _c(
                            "el-image",
                            {
                              staticClass: "design-card__img-inner",
                              attrs: {
                                src: _vm.designCards[2].bgImage,
                                fit: "cover",
                              },
                            },
                            [
                              _c("template", { slot: "placeholder" }, [
                                _c("div", {
                                  staticClass: "design-card__img-skeleton",
                                }),
                              ]),
                            ],
                            2
                          )
                        : _c("div", {
                            staticClass: "design-card__img-bg",
                            style: _vm.designCards[2].bgStyle,
                          }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm.$screen.mobile
        ? _c("RollBox", {
            attrs: {
              roiiListLoading: _vm.roiiListLoading,
              roiiHeroBg: _vm.roiiHeroBg,
              roiiList: _vm.roiiList,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }